import type { BuiltinBlockRegistry } from 'virtual:monospace-builtin-blocks';
import type { BlockDefinition, BlockSerialized } from '#layers/block-engine/types/block';
import { builtinBlocks } from 'virtual:monospace-builtin-blocks';
import { useBlockAdapter } from '#layers/block-engine/composables/use-block-adapter';

export function resolveSerializedBlock(blockId: string): Promise<BlockSerialized | undefined> {
	const { loadBlockSerialized } = useBlockAdapter();
	return loadBlockSerialized(blockId);
}

/**
 * Resolves builtin block definitions from the generated registry without
 * entering the async serialized-block resolution pipeline.
 */
export function resolveBuiltinBlock(blockId: string): BlockDefinition | undefined {
	return (builtinBlocks as BuiltinBlockRegistry)[blockId];
}
